import http from "@/utils/request";

// 主后台菜单
export function Reslist(data: any) {
  return http.post<Res.response<any>>({
    url: "/res/list",
    data,
  });
}
// 推送
export function modifyState(data: any) {
  return http.post<Res.response<any>>({
    url: "res/modifyState",
    data,
  });
}
// 编辑
export function reseditRes(data: any) {
  return http.post<Res.response<any>>({
    url: "res/sort",
    data,
  });
}
// 排序
export function resupdate(data: any) {
  return http.post<Res.response<any>>({
    url: "res/editRes",
    data,
  });
}
// 添加
export function resAddresone(data: any) {
  return http.post<Res.response<any>>({
    url: "res/addres",
    data,
  });
}
// 门店二级
export function resgetParRes(data: any) {
  return http.post<Res.response<any>>({
    url: "res/getParRes",
    data,
  });
}
// 二级添加

export function resAddres(data: any) {
  return http.post<Res.response<any>>({
    url: "res/addres",
    data,
  });
}

// 门店菜单
// 渲染
export function menulist(data1: any, data2?: any) {
  return http.get<Res.response<any>>({
    url: "/menu/list?menuParentId=" + data1 + "&menuName=" + data2,
  });
}
// 门店推送
export function menumodifyState(data: any) {
  return http.post<Res.response<any>>({
    url: "/menu/modifyState",
    data,
  });
}
// 门店添加
export function Addmenu(data: any) {
  return http.post<Res.response<any>>({
    url: "/menu",
    data,
  });
}
// 门店添加
export function Edmenu(data: any) {
  return http.put<Res.response<any>>({
    url: "/menu/update",
    data,
  });
}
